import React from 'react';
import PropTypes from 'prop-types';

import { useCurrentLang } from 'react-redux-app/lib/modules/i18n/hooks';


export default Link => {
  const propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  };

  const LangLink = ({ to, ...props }) => {
    const lang = useCurrentLang();

    let toWithLang;
    if (to?.pathname) {
      toWithLang = { ...to, pathname: `/${lang}${to.pathname}` };
    } else {
      toWithLang = `/${lang}${to}`;
    }

    return <Link {...props} to={toWithLang} />;
  };

  LangLink.propTypes = propTypes;

  return LangLink;
};
